export default __webpack_public_path__ + "static/media/slider-2.73561308.jpg";